import { ComponentProps, FC, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { CardNumberElement } from '@stripe/react-stripe-js';
import { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

import locales from '../../locales';
import StripeElementModifier from '../StripeElementModifier';
import { BRAND_ICONS_MAP, BrandIcon } from './styles';

type CardNumberInputProps = Omit<
  ComponentProps<typeof StripeElementModifier>,
  'stripeElement' // Omit stripeElement so it won't be overridden
>;

type BrandName = keyof typeof BRAND_ICONS_MAP;

/**
 * This component is needed to handle card brand icon on the field of the number.
 * Stripe doesn't allow this for now.
 * see https://github.com/stripe/react-stripe-elements/issues/74 or https://github.com/stripe/react-stripe-elements/issues/393
 * TODO(alex): remove this component once Stripe handles it
 */
const CardNumberInput: FC<CardNumberInputProps> = ({
  // Empty function used below as an easier to handle default value
  onChange = () => {},
  ...props
}) => {
  const [cardBrand, setCardBrand] = useState<BrandName>('unknown');

  return (
    <Box position="relative">
      <StripeElementModifier
        label={locales.cardNumberPlaceholder}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(event: any) => {
          const { brand } = event as StripeCardNumberElementChangeEvent;

          setCardBrand(
            brand in BRAND_ICONS_MAP ? (brand as BrandName) : 'unknown',
          );
          onChange(event);
        }}
        stripeElement={CardNumberElement}
        {...props}
      />
      <BrandIcon brand={cardBrand} />
    </Box>
  );
};

export default CardNumberInput;
